// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".body-ready-hidden {\r\n    visibility: hidden !important;\r\n}\r\n", "",{"version":3,"sources":["webpack://./packages/libs/common-util/browser/css/common-lib.css"],"names":[],"mappings":"AAAA","sourcesContent":[".body-ready-hidden {\r\n    visibility: hidden !important;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
